<template>
  <v-card class="pa-0 pb-10" tile>
    <Loader v-if="loading"/>
    <template v-else>
      <v-card-title>
        <h4 class="primary--text">
        {{ vehicle.name }}
        </h4>
      </v-card-title>
      <v-card-subtitle>
        <span>ID: {{ vehicle.registrationNumber }}</span>
      </v-card-subtitle>
      <div class="background px-6">
        <v-tabs v-model="activeTab" :height="60" background-color="background" show-arrows hide-slider center-active>
          <v-tab :ripple="false">{{ $t('common.details') }}</v-tab>
          <v-tab :ripple="false">{{ $t('fleet.roads.title') }}</v-tab>
          <v-tab :ripple="false">{{ $t('fleet.roads.archiveTitle') }}</v-tab>
        </v-tabs>
      </div>
      <v-tabs-items v-model="activeTab" class="py-4">
        <v-tab-item>
          <Information/>
        </v-tab-item>
        <v-tab-item>
          <Roads ref="activeRoads" @roadArchived="onRoadArchived"/>
        </v-tab-item>
        <v-tab-item>
          <Roads ref="archivedRoads" :isArchive="true"/>
        </v-tab-item>
      </v-tabs-items>
    </template>
  </v-card>
</template>

<script>
import Service from '@/services'
import Information from './Tabs/Information.vue'
import Roads from './Tabs/Roads.vue'
import Loader from '@/components/Loader'

export default {
  name: 'VehicleDetails',
  components: {
    Information,
    Roads,
    Loader
  },
  data () {
    return {
      loading: false,
      activeTab: 0,
      vehicle: {
      }
    }
  },
  async created () {
    await this.fetchData()
  },
  methods: {
    async fetchData () {
      this.loading = true
      try {
        const { data } = await Service.get('Fleet/GetDetails', { vehicleId: this.$route.params.id })
        this.vehicle = data
      } catch (e) {
      } finally {
        this.loading = false
      }
    },
    onRoadArchived () {
      if (this.$refs.archivedRoads) {
        this.$refs.archivedRoads.refresh()
      }
    }
  }
}
</script>
<style scoped>
.v-tab::before {
    display: block;
    content: attr(title);
    font-weight: bold;
    height: 0;
    overflow: hidden;
    visibility: hidden;
}

/* .v-tab--active, */
.v-tab:hover {
  /* font-weight: bold; */
  color: var(--v-primary-base) !important;
  text-shadow: 0 0 .7px var(--v-primary-base), 0 0 .7px var(--v-primary-base);
}

.v-tab--active:hover,
.v-tab--active {
  font-weight: bold;
  color: var(--v-primary-base) !important;
  text-shadow: none;
}
.v-tab {
  text-transform: none;
  border-left: solid 1px var(--v-separator-base);
  margin: 10px 0;
}
.v-tab:last-child {
  border-right: solid 1px var(--v-separator-base);
  margin: 10px 0;
}
</style>
